export function roundCurrency(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100
}

export function calculateBookingPricing({
    subtotal = 0,
    enableSurcharge = false,
    surchargeRate = 0,
    enableTax = false,
    taxRate = 0,
  }) {
  const normalizedSubtotal = roundCurrency(subtotal)
  const normalizedSurchargeRate = Number(surchargeRate) || 0
  const normalizedTaxRate = Number(taxRate) || 0

  const surcharge = enableSurcharge
    ? roundCurrency(normalizedSubtotal * (normalizedSurchargeRate / 100))
    : 0

  const taxBase = roundCurrency(normalizedSubtotal + surcharge)

  const tax = enableTax
    ? roundCurrency(taxBase * (normalizedTaxRate / 100))
    : 0

  const total = roundCurrency(normalizedSubtotal + surcharge + tax)

  return {
    subtotal: normalizedSubtotal,
    surcharge,
    tax,
    total,
    surchargeRate: normalizedSurchargeRate,
    taxRate: normalizedTaxRate,
    surchargeEnabled: !!enableSurcharge && normalizedSurchargeRate > 0,
    taxEnabled: !!enableTax && normalizedTaxRate > 0,
  }
}
